import effectManager from '../module/effect';

let effect = new effectManager();

export default class developer {
    constructor(){
        this.main = $(".p-developer-interview__main");
        this.copy = $(".p-developer-interview__copy");
        this.bg = $(".p-developer-interview__bg");
        this.content = $(".p-developer-interview__content");
        this.image = $(".p-developer-interview__image").children();
        this.link = $(".p-developer-interview__link");
    }

    init(_status){

        let _this = this;

        this.main = $(".p-developer-interview__main");
        this.copy = $(".p-developer-interview__copy");
        this.bg = $(".p-developer-interview__bg");
        this.content = $(".p-developer-interview__content");
        this.image = $(".p-developer-interview__image").children();
        this.link = $(".p-developer-interview__link");

        _status.scrollStart = false;
        _status.scrollEnd = true;

        setTimeout(function () {
            $('html,body').animate({ scrollTop: 0 }, '1');
        }, 1e3);


        //set
        TweenLite.set(this.bg, {
            opacity: 0,
            scale: 1.38,
            '-webkit-filter': 'blur(20px)',
            'filter': 'blur(20px)'
        });
        TweenLite.set(this.copy.find('.js__split-text').children().children(), {
            opacity:0,
            y:'100%',
        });
        TweenLite.set([this.content,this.image,this.link], {
            opacity:0,
        });
        $("#l-root").css({'display':'block'});
        setTimeout(function () {
            _this.motion(_status,_this);
        },800);

        $("#l-footer__social").css({"display":"none"});

    }

    motion(_status,_this){
        TweenMax.to(_this.bg, 1.48, {
            opacity:1,
            scale: 1,
            '-webkit-filter': 'blur(0px)',
            'filter': 'blur(0px)',
            easing:Expo.easeOut,
            onComplete:function(){
                _status.loading = true;
                $("#c-scroll").addClass('is-done');
                _status.Flg = false;
                _status.loading = true;
            }
        });
        TweenMax.staggerTo(_this.copy.find('.js__split-text').children().children(), .68, {
            y:'0%',
            ease: Expo.easeOut
        },.01);
        TweenMax.staggerTo(_this.copy.find('.js__split-text').children().children(), 1.68, {
            opacity:1,
            ease: Expo.easeOut
        },.01);
        TweenLite.set([_this.content,_this.image,_this.link], {
            delay:2.18,
            opacity:1,
        });
    }

    event(_status) {

        let $main = this.main;
        let $copy = this.copy;
        let $bg = this.bg;
        let $content = this.content;
        let $image = this.image;

        let $target = $('.p-developer-interview__link');
        let height = $target.outerHeight();
        TweenLite.set($target, {y: height});

        _status.Flg = true;

        // main hide → content show
        if(_status.changeType === 'next'){

            // set
            _status.scrollcount = 0;
            TweenLite.set($(".p-developer-interview__image"), {opacity: 1});
            $('#c-scroll').removeClass("is-done");
            TweenLite.set($content, {
                y: "18px",
                opacity:0,
            });
            TweenLite.set(this.image, {
                opacity: 0,
                x:'30px',
                scale: 1.12,
                '-webkit-filter': 'blur(7px)',
                'filter': 'blur(7px)'
            });

            // motion
            TweenMax.staggerTo($copy.find('.js__split-text'), .68, {
                y:'-30px',
                opacity:0,
                ease: Expo.easeOut
            },.04);
            TweenMax.to($bg, 2.68, {
                scale: 0.98,
                opacity: 0,
                ease: Expo.easeOut,
            });
            TweenMax.to($image, 1.18, {
                opacity:1,
                x:'0px',
                scale: 1,
                '-webkit-filter': 'blur(0px)',
                'filter': 'blur(0px)',
                easing:Expo.easeOut,
                onComplete: function () {
                    // status
                    $content.removeAttr('style');
                    $("#l-footer").addClass("is-hide");
                    $('html').removeClass('is-no-scroll');
                    $main.css({'z-index':'-1'});
                    _status.Flg = false;
                    _status.scrollStart = true;
                    _status.scrollEnd = false;
                }
            });
            TweenMax.to($content, .68, {
                delay:.3,
                y: "0px",
                opacity: 1,
                ease: Circ.easeOut
            });
        // content hide → main show
        }else{

            $('html').addClass('is-no-scroll');
            $main.css({'z-index':'5'});
            // set
            TweenLite.set($bg, {scale: 1.02});
            TweenLite.set($copy.find('.js__split-text'), {y: '-20px', opacity:0});

            // motion
            TweenMax.to($image, 1.18, {
                opacity:1,
                x:'0px',
                scale: 1,
                '-webkit-filter': 'blur(0px)',
                'filter': 'blur(0px)',
                easing:Expo.easeOut
            });

            TweenMax.to($content, 0.48, {
                y: "2%",
                opacity: 0.5,
                ease: Expo.easeOut,
                onComplete: function () {
                    $('#c-scroll').addClass("is-done");
                    $("#l-footer").removeClass("is-hide");
                    TweenMax.to($copy.find('.js__split-text').eq(2), 1.08, {
                        y:'0px',
                        opacity:1,
                        ease: Circ.easeOut
                    });
                    TweenMax.to($copy.find('.js__split-text').eq(1), 1.08, {
                        delay:0.1,
                        y:'0px',
                        opacity:1,
                        ease: Circ.easeOut
                    });
                    TweenMax.to($copy.find('.js__split-text').eq(0), 1.08, {
                        delay:0.2,
                        y:'0px',
                        opacity:1,
                        ease: Circ.easeOut
                    });
                    TweenMax.to($main, 0.48, {
                        delay: 0.3,
                        y: "0%",
                        opacity: 1,
                        ease: Expo.easeOut
                    });
                    TweenMax.to($bg, 0.88, {
                        scale: 1,
                        opacity: 1,
                        ease: Expo.easeOut,
                        onComplete: function () {
                            // status
                            _status.Flg = false;
                            _status.scrollStart = false;
                            _status.scrollEnd = true;
                        }
                    })
                }
            });
        }
    }

    /* -----------------------------------------------

     -- scroll

     -------------------------------------------------- */

    scroll(_status) {
        let $target = $('.p-developer-interview__link');
        let height = $target.outerHeight();
        let changePostion = $('.p-developer-interview__scroll').outerHeight()/5;
        let image = $('.p-developer-interview__image>*');

        if(_status.position === 'no_bottom'){
            TweenMax.to($target, 0.38, {
                y: height,
                ease: Expo.easeOut
            });
        }else{
            TweenLite.set($target, {y: height});
            TweenMax.to($target, 0.68, {
                y: "0%",
                ease: Expo.easeOut
            });
        }
        if(_status.scr > changePostion){
            if(_status.scrollcount === 1) return false;
            _status.scrollcount = 1;
            // set
            image.eq(0).removeClass("is-show");
            image.eq(1).addClass("is-show");
            TweenLite.set(image.eq(1), {
                opacity: 0,
                scale: 1.03,
                '-webkit-filter': 'blur(7px)',
                'filter': 'blur(7px)'
            });
            // motion
            TweenMax.to(image.eq(0), .68, {
                opacity:0,
                scale: 0.99,
                '-webkit-filter': 'blur(7px)',
                'filter': 'blur(7px)',
                easing:Expo.easeOut
            });
            TweenMax.to(image.eq(1), .68, {
                opacity:1,
                scale: 1,
                '-webkit-filter': 'blur(0px)',
                'filter': 'blur(0px)',
                easing:Circ.easeInOut
            });
        }else{
            if(_status.scrollcount === 0) return false;
            _status.scrollcount = 0;
            //set
            image.eq(0).addClass("is-show");
            image.eq(1).removeClass("is-show");
            TweenLite.set(image.eq(0), {
                opacity: 0,
                scale: 1.03,
                '-webkit-filter': 'blur(7px)',
                'filter': 'blur(7px)'
            });
            // motion
            TweenMax.to(image.eq(1), .68, {
                opacity:0,
                scale: 0.99,
                '-webkit-filter': 'blur(7px)',
                'filter': 'blur(7px)',
                easing:Expo.easeOut
            });
            TweenMax.to(image.eq(0), .68, {
                opacity:1,
                scale: 1,
                '-webkit-filter': 'blur(0px)',
                'filter': 'blur(0px)',
                easing:Circ.easeInOut
            });
        }
    }
}
